import { getLocalInstallationId } from "@/lib/logger";

interface DeviceInfo {
  os_id: string;
  os_name: string;
  device_type: string;
  brand: string | null;
  model: string | null;
}

export function getOsName(): string {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("iphone") || ua.includes("ipad")) return "ios";
  if (ua.includes("android")) return "android";
  if (ua.includes("mac os") || ua.includes("macos")) return "macos";
  if (ua.includes("windows")) return "windows";
  if (ua.includes("linux")) return "linux";
  if (ua.includes("cros")) return "chromeos";
  return "unknown";
}

function getBrowserName(): string | null {
  const uaData = (navigator as any).userAgentData;
  if (uaData?.brands?.length) {
    const brand = uaData.brands.find(
      (b: { brand: string }) =>
        !b.brand.includes("Not") && !b.brand.includes("Chromium")
    );
    if (brand) return brand.brand;
  }

  const ua = navigator.userAgent;
  if (ua.includes("Edg/")) return "Edge";
  if (ua.includes("OPR/") || ua.includes("Opera")) return "Opera";
  if (ua.includes("Firefox/")) return "Firefox";
  if (ua.includes("Chrome/") && !ua.includes("Edg/")) return "Chrome";
  if (ua.includes("Safari/") && !ua.includes("Chrome/")) return "Safari";
  return null;
}

function getOsVersion(): string | null {
  const ua = navigator.userAgent;

  const macMatch = ua.match(/Mac OS X (\d+[._]\d+(?:[._]\d+)?)/);
  if (macMatch) return macMatch[1].replace(/_/g, ".");

  const winMatch = ua.match(/Windows NT (\d+\.\d+)/);
  if (winMatch) {
    const ntVersionMap: Record<string, string> = {
      "10.0": "10+",
      "6.3": "8.1",
      "6.2": "8",
      "6.1": "7",
    };
    return ntVersionMap[winMatch[1]] ?? winMatch[1];
  }

  const androidMatch = ua.match(/Android (\d+(?:\.\d+)?)/);
  if (androidMatch) return androidMatch[1];

  const iosMatch = ua.match(/OS (\d+[._]\d+(?:[._]\d+)?)/);
  if (iosMatch) return iosMatch[1].replace(/_/g, ".");

  return null;
}

export function getDeviceInfo(): DeviceInfo {
  const osName = getOsName();
  const osVersion = getOsVersion();
  const browser = getBrowserName();

  return {
    os_id: getLocalInstallationId(),
    os_name: osName,
    device_type: "web",
    brand: browser,
    model: osVersion ? `${osName} ${osVersion}` : osName,
  };
}
